import { useDispatch, useSelector } from 'react-redux';
import { loadTranslations } from '../store/translationSlice';

export const useTranslation = () => {
  const translations = useSelector((state) => state.translation.translations);
  const currentLanguage = useSelector(
    (state) => state.translation.currentLanguage
  );
  const dispatch = useDispatch();
  
  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value[k] === undefined) {
        return ""; // Return empty string if not translation found
      }
      value = value[k];
    }

    if (typeof value !== 'string') {
      return '';
    }

    return Object.entries(params).reduce(
      (result, [paramKey, paramValue]) =>
        result.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(paramValue)),
      value,
    );
  };

  const changeLanguage = (language) => {
    dispatch(loadTranslations(language));
  };

  return { t, currentLanguage, changeLanguage, translations };
};
